var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-filter',{attrs:{"text":"Product","popup":_vm.popup,"filtered":_vm.filtered},on:{"update:popup":function($event){_vm.popup=$event}}},[_c('m-lookup',{attrs:{"data":_vm.products},on:{"select":_vm.select}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }